/* istanbul ignore file */

import { css } from 'styled-components';

import { MODAL_HEIGHT_CSS_VAR } from '../constants/cssVariables';

export const modalViewport = css`
  height: 100vh;
  height: var(${MODAL_HEIGHT_CSS_VAR});
  min-height: 100%;
`;
